import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["category", "note", "label"]

  connect() {
    this.categories = JSON.parse(this.data.get("categories") || "[]")
    this.toggleNote()
  }

  toggleNote() {
    const required = this.categories.includes(this.categoryTarget.value)

    this.noteTarget.required = required
    this.labelTarget.toggleAttribute("required", required)
  }
}
